import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxExamResult/";

// 线上成绩 - 我的成绩列表查询
export const gradesMyPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/grades.js